var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal","mode":"out-in"}},[(_vm.showModal)?_c(_vm.modalComponent,_vm._b({tag:"component",on:{"close":_vm.handleCloseModal}},'component',_vm.modalProperties,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }